import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { map,switchMap } from 'rxjs/operators';

import * as actions from '@redux/actions/product';
import * as productTypes from '@redux/actions/product/productTypes';
import { post } from '@services/genericService';
import SitecoreContextFactoryService from '@services/sitecoreContextFactoryService';

import * as configs from './config';

export const fetchProductInformation = (action$) =>
  action$.pipe(
    ofType(productTypes.GET_PRODUCT_INFORMATION),
    switchMap((action) => {
      const params = {
        productId: SitecoreContextFactoryService.getValueContextRouteItem('fields')?.['Commerce Product Source']?.fields?.ProductId?.value,
        itemId: SitecoreContextFactoryService.getValueContextRouteItem('fields')?.['Commerce Product Source']?.id,
        dataType: action.payload.dataType
      };
      
      return from(post(configs.ACTION, params)).pipe(
        map((res) => {
          if (res.status === 200) {
            return actions.getProductInformationSuccess(res);
          } else {

            return actions.getProductInformationFailed('Failed');
          }
        })
      );
    })
  );
